// Campaign attribution capture: reads ?utm_source= off the URL (e.g. from
// the elecomp1405 QR redirect) and stashes it in localStorage, following the
// same plain-localStorage convention this app already uses for other
// cross-page auth state (see `phonenumber`, `verify_otp_timer` in the
// login/verify/register flow) rather than introducing a store for a single
// ephemeral value. The stashed value is sent to the backend as `qr_code` on
// the register request (see RegisterRequest.qr_code in types/auth.ts) —
// the URL param and the API field are named differently on purpose.
const UTM_SOURCE_KEY = "utm_source";

export function stashUtmSource(searchParams: URLSearchParams | { get(key: string): string | null }) {
  const value = searchParams.get("utm_source");
  if (value) {
    localStorage.setItem(UTM_SOURCE_KEY, value);
  }
}

export function readUtmSource(): string | null {
  return localStorage.getItem(UTM_SOURCE_KEY);
}

export function clearUtmSource() {
  localStorage.removeItem(UTM_SOURCE_KEY);
}
